/** Minutes since midnight of a local "YYYY-MM-DDTHH:mm:ss"; a bare "THH:mm:ss" works too. */
const toMinutesOfDay = (dateTime: string): number => {
  const [, time = '00:00:00'] = dateTime.split('T');
  const [hours = 0, minutes = 0] = time.split(':').map(Number);
  return hours * 60 + minutes;
};

export default toMinutesOfDay;
